import styled from 'styled-components';
import {
  tokens,
  ModalOption,
  ModalWarning,
  Logo
} from '@plataforma/components';
import { colors } from '_/styles';

export const WarningIcon = styled(ModalWarning)``;
export const Children = styled.span``;
export const Modal = styled(ModalOption)`
  & div {
    background-color: ${({ darkTheme }) =>
      darkTheme ? colors.textAlternative : colors.background};
  }

  & > button > svg > g {
    fill: ${({ darkTheme }) =>
      darkTheme ? colors.background : colors.baseElectricViolet};
  }

  a {
    text-decoration: none;
    color: ${colors.main};
    font-weight: ${tokens.font.weight.semibold};
  }

  p:first-child {
    margin-bottom: 32px;
  }

  ${({ modalSelectUser }) =>
    modalSelectUser &&
    `
    > div {
      width: 410px;

      > div span:last-of-type {
        width: 100%;
        text-align: left;
      }
    }
  `}

  ${({ noIcon }) =>
    noIcon &&
    `
    div {
      min-height: unset;

      > span:first-child {
        font-size: 26px;
        margin-top: 0;
      }
    }
  `}
`;

export const LogoJunto = styled(Logo)`
  width: 150px;
  height: auto;
  margin-bottom: 12px;
`;
